module.exports = __webpack_public_path__ + "static/img/thumb_02.4d15761.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/about/thumb_02.jpg
// module id = 29
// module chunks = 0